<style scoped>
.banner-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  margin: 0 0px 20px 0;
  /* >1600px: fixed height, crops sides */
  height: 450px;
}

.banner-wrapper picture {
  display: block;
  width: 100%;
  height: 100%;
}

.banner-link {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.banner-wrapper img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}

/* 1600px → 1500px: proportional resize (25vw = 400px at 1600px) */
@media (max-width: 1600px) {
  .banner-wrapper {
    height: 25vw;
  }
}

/* <1500px: fixed height, crops sides again (25vw @ 1500px = 375px) */
@media (max-width: 1500px) {
  .banner-wrapper {
    height: 375px;
  }
}

/* 901px → 1372px: keep full desktop image visible (no side crop) */
@media (max-width: 1372px) and (min-width: 901px) {
  .banner-wrapper {
    height: auto;
  }
  .banner-wrapper picture,
  .banner-wrapper img {
    height: auto;
  }
}

/* <900px: mobile image, natural height */
@media (max-width: 900px) {
  .banner-wrapper {
    height: auto;
  }
  .banner-wrapper picture,
  .banner-wrapper img {
    height: auto;
  }
}

.banner-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  line-height: 1.8;
  pointer-events: none;
}

.banner-cta {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 3;
}

.banner-cta:hover {
  position: absolute !important; 
}
</style>

<template>
  <div v-if="imageDesktop" class="banner-wrapper">
    <picture>
      <source v-if="imageMobile" media="(max-width: 900px)" :srcset="imageMobile" />
      <img :src="imageDesktop" :alt="imageAlt" />
    </picture>

    <a
      v-if="ctaUrl"
      class="banner-link"
      :href="ctaUrl"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="imageAlt"
    ></a>

    <span class="banner-badge">Publicidad</span>

    <v-btn
      v-if="ctaText && ctaUrl"
      class="banner-cta"
      color="orange"
      dark
      :href="ctaUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ ctaText }}
    </v-btn>
    
  </div>
</template>

<script>
export default {
  name: 'Banner',

  props: {
    imageDesktop: {
      type: String,
      default: ''
    },
    imageMobile: {
      type: String,
      default: ''
    },
    ctaUrl: {
      type: String,
      default: ''
    },
    ctaText: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: 'Banner publicitario'
    }
  }
}
</script>
